import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import {
  FlexCommunicatorService,
  FlexConnectionStatus,
} from '@fleet/flex/flex-communicator.service';

@Component({
    selector: 'fleet-flex-communication-banner',
    imports: [CommonModule, MatIconModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    template: `
    @if (shouldShowBanner()) {
      <div
        class="flex items-center justify-center w-full px-4 py-2 text-sm font-medium transition-all duration-500 ease-in-out transform"
      [ngClass]="{
        'bg-green-100 text-green-800 border-b border-green-200 dark:bg-green-900 dark:text-green-200 dark:border-green-700':
          connectionStatus().isConnected,
        'bg-red-100 text-red-800 border-b border-red-200 dark:bg-red-900 dark:text-red-200 dark:border-red-700':
          !connectionStatus().isConnected
      }"
        >
        <mat-icon
          class="mr-2 text-base transition-colors duration-300"
        [ngClass]="{
          'text-green-600 dark:text-green-400': connectionStatus().isConnected,
          'text-red-600 dark:text-red-400': !connectionStatus().isConnected
        }"
          >
          {{ connectionStatus().isConnected ? 'link' : 'link_off' }}
        </mat-icon>
        <span
          class="animate-pulse"
          [class.animate-pulse]="!connectionStatus().isConnected"
          >
          {{
          connectionStatus().isConnected
          ? 'In communication with Flex'
          : 'Communication with Flex lost'
          }}
        </span>
      </div>
    }
    `,
    styles: []
})
export class FlexCommunicationBannerComponent implements OnInit {
  connectionStatus = signal<FlexConnectionStatus>({ isConnected: false });
  shouldShowBanner = signal(false);

  constructor(private flexCommunicatorService: FlexCommunicatorService) {
    // Subscribe in constructor as per workspace rules
    this.flexCommunicatorService.isConnected$
      .pipe(takeUntilDestroyed())
      .subscribe({
        next: (status: FlexConnectionStatus) => {
          console.log(
            '[FlexBanner] Received connection status update:',
            status
          );
          this.connectionStatus.set(status);
          // Only show banner after initial connection attempt or if we lose connection
          const previousShouldShow = this.shouldShowBanner();
          const shouldShow =
            status.isConnected || status.lastHeartbeat !== undefined;
          this.shouldShowBanner.set(shouldShow);
          console.log(
            '[FlexBanner] Should show banner:',
            shouldShow,
            '(was:',
            previousShouldShow,
            ')'
          );
          console.log(
            '[FlexBanner] Connection status:',
            status.isConnected,
            'Last heartbeat:',
            status.lastHeartbeat
          );
        },
        error: (error) => {
          console.error(
            '[FlexBanner] Error receiving connection status:',
            error
          );
        },
      });
  }

  ngOnInit(): void {
    console.log('[FlexBanner] Component initialized');
  }
}
